import type { SolarMapStepData } from "./SolarMapStep.tsx";
import type { ErrorSeverity } from "../../types/error";
import { DEFAULT_ERROR_SEVERITY } from "../../types/error";

export type SolarMapStepState = {
    markerPosition: SolarMapStepData["markerPosition"];
    buildingInsights: SolarMapStepData["buildingInsights"] | null;
    isLoading: boolean;
    error: string | null;
    errorSeverity?: ErrorSeverity;
};

export type SolarMapStepAction =
    | { type: "HYDRATE"; payload: SolarMapStepData | undefined; fallbackMarkerPosition: SolarMapStepData["markerPosition"] }
    | { type: "LOAD_START" }
    | { type: "LOAD_SUCCESS"; payload: SolarMapStepData }
    | { type: "LOAD_ERROR"; payload: string; severity?: ErrorSeverity };

export const initialSolarMapStepState = (
    stepData: SolarMapStepData | undefined,
    fallbackMarkerPosition: SolarMapStepData["markerPosition"]
): SolarMapStepState => ({
    markerPosition: stepData?.markerPosition ?? fallbackMarkerPosition,
    buildingInsights: stepData?.buildingInsights ?? null,
    isLoading: false,
    error: null,
    errorSeverity: DEFAULT_ERROR_SEVERITY,
});

export const solarMapStepReducer = (
    state: SolarMapStepState,
    action: SolarMapStepAction
): SolarMapStepState => {
    switch (action.type) {
        case "HYDRATE":
            return initialSolarMapStepState(action.payload, action.fallbackMarkerPosition);
        case "LOAD_START":
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case "LOAD_SUCCESS":
            return {
                ...state,
                isLoading: false,
                error: null,
                buildingInsights: action.payload.buildingInsights,
                markerPosition: action.payload.markerPosition,
            };
        case "LOAD_ERROR":
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                errorSeverity: action.severity ?? DEFAULT_ERROR_SEVERITY,
            };
        default:
            return state;
    }
};
